<!--
    Styles
-->

<style>


    /* main */

    .ui-search {
        height: 34px;
    }
    .ui-search svg {
        width: 20px;
        height: 20px;
        margin-left: 6px;
    }
    .ui-search input {
        height: 100%;
        padding-left: 6px;
    }


</style>



<!--
    Template
-->

<template>
    <div class="ui-search u-row">
        <icon-search class="cl-blue" />
        <input
            ref="input"
            type="text"
            placeholder="渋谷区 , 神泉駅"
            @input="$emit('input', $event.target.value)"
            :value="value"
            :disabled="disabled"
            @compositionstart="composing = true"
            @compositionend="composing = false"
            @keydown.enter.prevent="enter"
        >
        <slot />
    </div>
</template>



<!--
    Scripts
-->

<script>


    import iconSearch from '@/assets/icons/search.svg'


    export default {

        components: {
            iconSearch
        },

        props: ['value', 'focus', 'disabled'],

        data () {
            return {
                composing: false
            }
        },

        methods: {

            enter (event) {
                if (this.composing) return;
                this.$emit('enter', event.target.value);
                this.$refs.input.blur();
            }

        }

    }

</script>
